import React, { Component } from "react";
import { Table, Icon, Alert } from "antd";
import TableColumnWithTooltip from "../shared/TableColumnWithTooltip/TableColumnWithTooltip";
import { semTableColumns } from "../shared/TableColumnWithTooltip/semTableColumns";
import KeywordPosition from "../shared/KeywordPosition";
import { TopDomains, TrendChart } from "../../containers";
import LoadingIndicator from "../shared/LoadingIndicator/LoadingIndicator";
import ModalTitle from "../shared/ModalTitle/ModalTitle";

const { Column } = Table;

const trendRender = (record) =>
  record.position ? (
    <TrendChart
      openLabel={<Icon type="bar-chart" />}
      modalTitle={<ModalTitle title="Trend chart for:" meta={record.keyword} />}
      seoDb={record.seoDb}
      keyword={record.keyword}
      domain={record.domain}
    />
  ) : (
    "-"
  );

const topDomainsRender = (record) =>
  record.position ? (
    <TopDomains
      openLabel="View list"
      modalTitle={<ModalTitle title="Top domains for: " meta={record.keyword} />}
      keyword={record.keyword}
      seoDb={record.seoDb}
    />
  ) : (
    "-"
  );

const urlRender = (record) => {
  if (record.url) {
    return (
      <a target="_blank" href={record.url} rel="noopener noreferrer">
        {record.url}
      </a>
    );
  }
  return "-";
};
class TrackedKeywordsTable extends Component {
  render() {
    const { isLoading, keywords, handleDelete, keywordsBeingDeleted } = this.props;
    const tableDataSource = keywords
      .sort((a, b) => (a.c_at < b.c_at ? -1 : a.c_at > b.c_at ? 1 : 0))
      .map((keyword, idx) => ({
        key: idx + 1,
        keyword: keyword.phrase,
        position: keyword["pos"] ? parseInt(keyword["pos"]) : null,
        previousPosition: keyword["prev_pos"] ? parseInt(keyword["prev_pos"]) : 0,
        trend: null,
        topDomains: null,
        searchVolume: keyword["vol"] ? parseInt(keyword["vol"]).toLocaleString() : "-",
        cpc: keyword["cpc"] ? parseFloat(keyword["cpc"]).toLocaleString() : "-",
        resultsNo: keyword["r_no"] ? parseInt(keyword["r_no"]).toLocaleString() : "-",
        url: keyword.url,
        status: keyword.status,
        domain: keyword.domain,
        seoDb: keyword.db,
      }));

    if (isLoading) {
      return <LoadingIndicator />;
    }
    return keywords.length ? (
      <Table dataSource={tableDataSource} pagination={false} size="small">
        <Column title="#" dataIndex="key" />
        <Column className="no-wrap" title="Keyword" dataIndex="keyword" />
        <Column
          title={<TableColumnWithTooltip {...semTableColumns["position"]} />}
          dataIndex="position"
          render={(_, record) => <KeywordPosition {...record} />}
        />
        <Column className="al-center" title="Trend" dataIndex="trend" render={(_, record) => trendRender(record)} />
        <Column
          className="al-center"
          title={<TableColumnWithTooltip {...semTableColumns["top_domains"]} />}
          dataIndex="topDomains"
          render={(_, record) => topDomainsRender(record)}
        />
        <Column
          className="al-right"
          title={<TableColumnWithTooltip {...semTableColumns["search_volume"]} />}
          dataIndex="searchVolume"
        />
        <Column className="al-right" title={<TableColumnWithTooltip {...semTableColumns["cpc"]} />} dataIndex="cpc" />
        <Column
          className="al-right"
          title={<TableColumnWithTooltip {...semTableColumns["results_no"]} />}
          dataIndex="resultsNo"
        />
        <Column
          className="truncate al-right"
          title={<TableColumnWithTooltip {...semTableColumns["url"]} />}
          dataIndex="url"
          render={(_, record) => urlRender(record)}
        />
        <Column
          className="no-wrap al-right"
          title="Action"
          dataIndex="operation"
          render={(_, record) => {
            return (
              <span
                className={"remove-item" + (keywordsBeingDeleted.includes(record.keyword) ? " in-progress" : "")}
                onClick={() => handleDelete(record.keyword)}>
                {keywordsBeingDeleted.includes(record.keyword) ? <Icon type="loading" /> : <Icon type="delete" />}
              </span>
            );
          }}
        />
      </Table>
    ) : (
      <Alert message="You haven't set any keywords to track for this domain!" />
    );
  }
}

export default TrackedKeywordsTable;
